import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutSituation,
  StepCard,
  Divider,
  SearchBar,
  ResultsBloc,
  TagsBloc,
  SituationCard,
} from "../../components";
import { head, map } from "lodash";
import {
  DividerContainer,
  StepCardContainer,
  SearBarContainer,
  ResultsBlocContainer,
  TagsContainer,
  ThematiqueBloc,
} from "./styled-components";
import { searchInAlerteData } from "../../helper/search";
import { ReactComponent as AlertIcon } from "../../assets/illustrations/alert.svg";

const Thematic = ({ data, steps }: { data: Domain; steps: Step[] }) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [results, setResults] = useState<SearchResult[] | null>();
  const [searchedValue, setSearchedValue] = useState("");
  const [thematic, setThematic] = useState<{ value: string; label: string }>({
    value: "",
    label: "",
  });
  const [themes, setTheme] = useState<Theme[]>();

  const thematiques = head(data.situations)?.thematique;

  const options = map(thematiques, ({ label, value, themes }) => ({
    label,
    value,
    themes,
  }));

  useEffect(() => {
    if (state && state.thematique) {
      const theme = options.find((option) => option.value === state.thematique);

      setThematic({ value: theme?.value, label: theme?.label });
      setTheme(theme?.themes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelectValue = (option: Thematique) => {
    setThematic({ value: option.value, label: option.label });
    setTheme(option.themes);
  };

  const onSearchValue = (value: string) => setSearchedValue(value);

  const onDeleteSearch = () => {
    setResults(null);
    setSearchedValue("");
  };

  const handleSearchResults = () =>
    setResults(searchInAlerteData(searchedValue) as any);

  return (
    <LayoutSituation
      withUrgencyNumber={false}
      steps={steps}
      activeStep={3}
      onPrevious={() => navigate("/alerte")}
    >
      <>
        <StepCardContainer>
          <StepCard
            color={data.color.light}
            step={`ÉTAPE 3 - ${data.step.title}`}
            title={data.step.subtitle}
            icon={<AlertIcon />}
          />
        </StepCardContainer>
        <SearBarContainer>
          <SearchBar
            domain="alerte"
            searchedValue={searchedValue}
            onSearchValue={onSearchValue}
            handleSearchResults={handleSearchResults}
            onDeleteSearch={onDeleteSearch}
          />
        </SearBarContainer>
        {results ? (
          <ResultsBlocContainer>
            <ResultsBloc results={results} searchedValue={searchedValue} />
          </ResultsBlocContainer>
        ) : (
          <>
            <DividerContainer>
              <Divider />
            </DividerContainer>
            <TagsContainer>
              <TagsBloc
                onSelect={onSelectValue}
                selectedValue={thematic.value}
                options={options}
              />
            </TagsContainer>
          </>
        )}
        <ThematiqueBloc>
          {themes &&
            map(themes, (theme) => (
              <SituationCard
                key={theme.id}
                title={thematic.label}
                description={theme.value}
                color="orange"
                onClick={() =>
                  navigate(
                    `/alerte/${head(data.situations)?.title}/${
                      thematic.value
                    }/${theme.id}`
                  )
                }
              />
            ))}
        </ThematiqueBloc>
      </>
    </LayoutSituation>
  );
};

export default Thematic;
